import { domainThemes } from "../constants/theme";


export const getDomainTheme = () => {
    const product = window.location.hostname.split('.')[1];

    const defaultTheme = {
        logo: "img/logo.png",
        productName: "Gamelords",
    };

    return domainThemes[product] || defaultTheme;
};




// WEBPACK FOOTER //
// ./src/utils/domainTheme.js